import { useCallback } from 'react';

import { toast, ToastProps } from '@motorway/mw-highway-code/pre-alpha';

type ErrorToastType = {
  message?: string;
  title?: string;
}

const sendToast = ({ message, title }: ErrorToastType, variant: ToastProps['variant']) => {
  if (!title || !message) {
    toast({
      content: title || message,
      variant,
    });
    return;
  }

  toast({
    content: message,
    heading: title,
    variant,
  });
};

const useToastNotification = () => {
  const showErrorToast = useCallback((props: ErrorToastType) => {
    sendToast(props, 'error');
  }, []);

  const showSuccessToast = useCallback((props: ErrorToastType) => {
    sendToast(props, 'success');
  }, []);

  return {
    showErrorNotification: showErrorToast,
    showSuccessNotification: showSuccessToast,
  };
};

export default useToastNotification;
